<div class="blog-symbol-section" [class.symbol-header]="position === 'header'" [class.symbol-footer]="position === 'footer'">
  <!-- Loading state -->
  <div *ngIf="loading" class="symbol-loading">
    <!-- Optional: Add a subtle loading indicator if needed -->
  </div>

  <!-- Symbol content -->
  <builder-content
    *ngIf="symbolContent && !loading"
    [model]="model"
    [content]="symbolContent"
    [apiKey]="apiKey">
  </builder-content>
</div>

